<template>
  <div>
    <el-button
      ref="previewBtn"
      type="text"
      v-if="this.value.data"
      @click="isShow = true"
      >已配置</el-button
    >
    <el-button v-else @click="isShow = true">打开地图</el-button>
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      :title="title || '地图标绘'"
      width="80%"
      @close="cancel"
    >
      <div class="content" v-loading="!mapLoadCompleted">
        <iframe
          v-if="isShowIframe"
          ref="saasIframe"
          :src="`${appSaasUrl}/baseMap`"
          frameborder="0"
          height="100%"
          width="100%"
        ></iframe>
        <el-empty
          description="加载地图失败，请配置saas平台地址"
          v-else
        ></el-empty>
      </div>
      <span slot="footer">
        <el-button type="default" plain size="small" @click="cancel"
          >取 消</el-button
        >
        <el-button
          :type="!mapLoadCompleted ? 'default' : 'primary'"
          :plain="!mapLoadCompleted"
          :disabled="!mapLoadCompleted"
          size="small"
          @click="submit"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "Mars3dPicker",
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: () => {
        return {
          fileName: undefined,
          dataType: undefined, // graphicGeoJSON | graphicJSON
          data: undefined, // 字符串
        };
      },
    },
    appSaasUrl: {
      type: String,
      default: "",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(v) {
        if (v.data) {
          console.log(v);
          // 保证预览下也能点击
          this.$nextTick(() => {
            const domBtn = this.$refs.previewBtn.$el;
            domBtn.removeAttribute("disabled");
            domBtn.classList.remove("is-disabled");
          });
        }
      },
      immediate: true,
      deep: true,
    },
    isShow(v) {
      this.dialogVisible = v;
      if (v) {
        this.isShowIframe = false;
        this.mapLoadCompleted = false;
        if (this.appSaasUrl) {
          this.isShowIframe = true;
          this.$message.warning("地图组件启动中...请稍候");
          this.$nextTick(() => {
            this.saasDom = this.$refs["saasIframe"];
            // 监听iframe传入的信息
            window.removeEventListener("message", this.getIframeMessage);
            window.addEventListener("message", this.getIframeMessage);
            const timer = setTimeout(() => {
              this.init();
              clearTimeout(timer);
            }, 3000);
          });
        } else {
          this.mapLoadCompleted = true;
        }
      } else {
        window.removeEventListener("message", this.getIframeMessage);
      }
    },
    mapLoadCompleted(v) {
      if (this.appSaasUrl && v) {
        this.$message.success("地图组件加载完成");
        // 加载已有数据
        this.loadAlreadyData();
      }
    },
  },
  data() {
    return {
      // 是否显示弹框
      dialogVisible: false,
      // 是否加载iframe
      isShowIframe: false,
      // iframe Dom
      saasDom: "",
      // 不同于开发使用的天地图密钥
      differentTdtKey: "789e558be762ff832392a0393fd8a4f1",
      // 是否加载完成
      mapLoadCompleted: false,
      isShow: false,
    };
  },
  methods: {
    // 初始化地图
    init() {
      this.saasDom.contentWindow.postMessage(
        {
          type: "baseMapInit",
          tk: this.differentTdtKey,
          mapConfig: {
            mapName: `${this.title}_${Math.random()}`, // 地图名称
            toolBarButtonsShowKeyList: [
              "homeButton", // 视角复位
              "zoom", // 缩放
              "sceneModePicker", // 二三维切换
              "baseLayerPicker", // 底图切换
              "locationBar", // 状态栏
              "distanceLegend", // 比例尺
              "navigationHelpButton", // 帮助按钮
            ],
            isAutoEditing: true, // 标绘图层自动激活编辑
          },
        },
        "*"
      );
    },
    // 加载已有数据
    loadAlreadyData() {
      const { fileName, dataType, data } = this.value || {};
      // if (dataType && data) {
      // 	const dataJson = JSON.parse(data);
      // 	if (dataJson?.length) {
      // 		const parentLayer = dataJson[0].attr.parentLayer;
      // 		const drawData = [
      // 			{
      // 				id: parentLayer.id,
      // 				name: `${fileName || '默认数据图层'}`,
      // 				code: `notDesignDraw_code_${Math.random()}`,
      // 				featureSize: dataType === 'graphicJSON' ? dataJson.length : dataJson.features.length,
      // 				type: dataType,
      // 				config: { isShow: true, flyTo: false },
      // 				data: dataJson,
      // 			},
      // 		];
      // 		this.saasDom.contentWindow.postMessage(
      // 			{
      // 				type: 'drawData',
      // 				drawData,
      // 			},
      // 			'*'
      // 		);
      // 	}
      // }
      if (dataType && data) {
        let drawData = [];
        let length = 0;
        const dataJson = JSON.parse(data);
        let realJson = [];
        switch (dataType) {
          case "graphicJSON":
            if (Array.isArray(dataJson)) {
              // 图层
              length = dataJson?.length || 0;
              realJson = dataJson;
            } else if (typeof dataJson === "object") {
              // 图像
              length = 1;
              realJson = [dataJson];
            }
            break;
          case "graphicGeoJSON":
            if (dataJson.type === "FeatureCollection") {
              // 图层
              length = dataJson.features?.length || 0;
              realJson = dataJson;
            } else if (dataJson.type === "Feature") {
              // 图像
              length = 1;
              realJson = {
                type: "FeatureCollection",
                features: [dataJson],
              };
            }

            break;
        }
        if (length) {
          drawData = [
            {
              id: `notDesignDraw_id_${Math.random()}`,
              name: `${fileName || "默认数据图层"}`,
              code: `notDesignDraw_code_${Math.random()}`,
              featureSize: length,
              type: dataType,
              config: { isShow: true, flyTo: false },
              data: realJson,
            },
          ];
        }
        this.saasDom.contentWindow.postMessage(
          {
            type: "drawData",
            drawData,
          },
          "*"
        );
      }
    },
    // 监听iframe返回
    getIframeMessage(event) {
      const { data } = event || {};
      const { type, ...other } = data || {};
      switch (type) {
        // 地图是否加载完成回调
        case "mapLoadCompleted":
          this.mapLoadCompleted = { ...other }.mapLoadCompleted;
          console.log({ ...other });
          break;
        // json数据导出到父级
        case "jsonDataIframe":
          this.$confirm("确认绘制，并转换为JSON格式？", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              console.log({ ...other, dataType: "graphicJSON" });
              this.$emit("input", { ...other, dataType: "graphicJSON" });
              this.cancel();
            })
            .catch(() => {});
          break;
        // geojson数据导出到父级
        case "geojsonDataIframe":
          this.$confirm("确认绘制，并转换为GeoJSON格式？", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              console.log({ ...other, dataType: "graphicGeoJSON" });
              this.$emit("input", { ...other, dataType: "graphicGeoJSON" });
              this.cancel();
            })
            .catch(() => {});
          break;
        // 点击图像获取详情数据
        case "graphicDetail":
          console.log({ ...other });
          break;
        // 操作返回回调数据
        case "interfaceCallBack":
          console.log({ ...other });
          break;
      }
    },
    submit() {
      // 创建组件
      // 注：不能直接在message使用h函数构建el-radio-group，因为切换选项不会更新dom
      const dataTypeRadio = Vue.component("dataTypeRadio", {
        data() {
          return {
            dataType: "geojson",
            dataTypeList: [
              {
                value: "geojson",
                label: "GeoJSON格式",
              },
              {
                value: "json",
                label: "JSON格式",
              },
            ],
          };
        },
        render(h) {
          return h(
            "el-radio-group",
            {
              props: {
                value: this.dataType,
              },
              on: {
                input: (value) => {
                  this.dataType = value;
                  this.$emit(
                    "change",
                    this.dataTypeList.find((e) => e.value === value)
                  );
                },
              },
            },
            [
              this.dataTypeList.map(({ value, label }, index) => {
                return h(
                  "el-radio",
                  {
                    key: `radio_${index}`,
                    props: {
                      label: value,
                    },
                  },
                  label
                );
              }),
            ]
          );
        },
        mounted() {
          this.dataType = "geojson";
        },
      });
      let checkedDataType = {
        value: "geojson",
        label: "GeoJSON格式",
      };
      const h = this.$createElement;
      this.$msgbox({
        title: "选择保存的数据类型",
        message: h(dataTypeRadio, {
          on: {
            change: (value) => {
              checkedDataType = value;
            },
          },
        }),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.saasDom.contentWindow.postMessage(
            {
              type: "interfaceCall",
              interfaceCall: {
                action: "getDrawData",
                args: {
                  dataType: checkedDataType.value, // geojson/json
                },
              },
            },
            "*"
          );
        })
        .catch(() => {});
    },
    cancel() {
      this.isShow = false;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
